// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 37) return "static/chunks/37-49fa1056ff46a1d6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"601":"a97e99318d4a93dd","708":"225314c9e22077c1","886":"d0b44ed2599bb923"}[chunkId] + ".js";
};